import {BaseApiService} from "../../../../infrastructure/domain-services/base-api-service";
import {InitialRequestParams} from "../../../../core/models/initial-request-params";

export class LocaleApi extends BaseApiService {

  static injectables = [...BaseApiService.injectables];

  url(requestParams: InitialRequestParams) {
    const route = this.root + requestParams.toString();

    return route;
  }
}

